<template>
  <div id="app">
    <el-container>
      <el-header height="160px"
         v-show="$route.path !== '/ipInfo'" ><Header @getStatus='getStatus' :style="{backgroundColor: top? 'rgb(15, 2, 32)': 'transparent'}"/>
        <div style="height:160px,"></div>
      </el-header>
      <el-main style="padding:0"><router-view :sign='sign'/></el-main>
      <div v-show="$route.path !== '/ipInfo'"><Footer/></div>
    </el-container>

  </div>
</template>

<script>
import Header from "@/components/header.vue";
import Footer from "@/components/footer.vue";
export default {
  data(){
    return {
      top:0,
      sign:false
    }
  },
  created(){
     this.sign = !!sessionStorage["token"] || false;
  },
  mounted(){
    this.$nextTick(()=>{
      window.addEventListener('scroll',this.handleScroll)
    })
  },
  destroyed(){
    window.removeEventListener('scroll',this.handleScroll)
  },
  methods:{
    handleScroll(){
      this.top = document.documentElement.scrollTop || document.body.scrollTop;
    },
    getStatus(){
      this.sign = sessionStorage["token"] || false;
    }
  },
  components: {
    Header,
    Footer
  },
  // watch:{
  //   '$route.path':{
  //     immediate: true,
  //     handler(val){
  //       console.log(val)
  //     }
  //   }
  // }
};

</script>


<style lang="less">
#app {
  transition: margin-left 0.08s;
  position: relative;
  background-color: #390aa7!important;
  background-image:  url("../src/images/bg.png");
  background-repeat: repeat-y;
}


</style>



// WEBPACK FOOTER //
// src/App.vue